/** 
*@author: satyamurthy.a
*@Description : 
**/
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { Form, message, Button, Select } from "antd";
import localStorage from "../../../utils/localStorage";
import { API_AUTH, API_SITE, GETUSERLIST } from "../../../commons/api";

const { Option } = Select;

const ChangePassword = ({ translationCache }) => {
  const [siteList, setSiteList] = useState([]);
  const [userList, setUserList] = useState([]);
  const editProfile = useRef(null);

  useEffect(() => {
    getSitesList();
  }, []);

  const onFinish = (data) => {
    const siteId = localStorage.get("currentSite");
    const accessToken = localStorage.get("accessToken");
    const changePassword = {
      method: "POST",
      url: `${API_AUTH.UpdateTokenStatus}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data,
    };
    axios(changePassword)
      .then((response) => {
        message.success(response.data.message);
      })
      .catch((error) => {
        if (error.response.status === 400) {
          message.error(error.response.data.message);
        }
      });
  };

  const getSitesList = () => {
    const siteId = localStorage.get("currentSite");
    const accessToken = localStorage.get("accessToken");
    const requestConfig = {
      method: "GET",
      url: `${API_SITE.GET}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    axios(requestConfig)
      .then((response) => {
        setSiteList(response.data);
      })
      .catch((err) => {
        if (err.response.status === 400 || err.response.status === 500) {
          message.info(err.response.data.message);
        }
      });
  };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword]
      ? translationCache[keyword]
      : keyword;
  };

  const onSiteIdChange = (SiteId) => {
    const Site = localStorage.get("currentSite");
    const accessToken = localStorage.get("accessToken");
    const orgHeaders = {
      method: "GET",
      url: `${GETUSERLIST.UserList}?SiteId=${Site}&Site=${SiteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data: {
        SiteId,
      },
    };
    axios(orgHeaders)
      .then((response) => {
        setUserList(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div>
      <Form
        ref={editProfile}
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          label={translation("Select Site")}
          name="SiteId"
          rules={[{ required: true, message: "Select Site" }]}
        >
          <Select
            style={{ width: "300px" }}
            onChange={onSiteIdChange}
          >
            {siteList.map((site) => (
              <Option key={site.Id} value={site.Id}>
                {site.Name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label={translation("Select Users")}
          name="UserIds"
          rules={[{ required: true, message: "Select Users" }]}
        >
          <Select mode="multiple" style={{ width: "300px" }}>
            {userList.map((user) => (
              <Option key={user.Id} value={user.Id}>
                {user.FirstName}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label={translation("Select Status")}
          name="Status"
          rules={[{ required: true, message: "Select Status" }]}
        >
          <Select style={{ width: "300px" }}>
            <Option value={true}>true</Option>
            <Option value={false}>false</Option>
          </Select>
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button type="primary" htmlType="submit">
            {translation("Submit")}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
});

export default connect(mapStateToProps)(ChangePassword);